import request from '@/utils/request'

// 获取问题列表
export function getQuestions(params) {
  return request({
    url: '/helpforum/questions',
    method: 'get',
    params
  })
}

// 发布问题
export function postQuestion(data) {
  return request({
    url: '/helpforum/questions',
    method: 'post',
    data
  })
}

// 获取问题详情
export function getQuestionDetail(params) {
  return request({
    url: '/helpforum/question',
    method: 'get',
    params
  })
}

// 添加回复
export function addReply(data) {
  return request({
    url: '/helpforum/replies',
    method: 'post',
    data
  })
}

// 标记问题为已解决
export function markAsSolved(data) {
  return request({
    url: '/helpforum/solve',
    method: 'post',
    data
  })
}

// 删除问题
export function deleteQuestion(data) {
  return request({
    url: '/helpforum/question',
    method: 'delete',
    data
  })
}

// 删除回复
export function deleteReply(data) {
  return request({
    url: '/helpforum/reply',
    method: 'delete',
    data
  })
}

// 采纳为最佳答案
export function markAsBestAnswer(data) {
  return request({
    url: '/helpforum/bestanswer',
    method: 'post',
    data
  })
}

// 问题点赞
export function likeQuestion(data) {
  return request({
    url: '/helpforum/like/question',
    method: 'post',
    data
  })
}

// 回复点赞
export function likeReply(data) {
  return request({
    url: '/helpforum/like/reply',
    method: 'post',
    data
  })
}

// 获取用户点赞状态
export function getUserLikeStatus(params) {
  return request({
    url: '/helpforum/like/status',
    method: 'get',
    params
  })
}

// 取消问题点赞
export function unlikeQuestion(data) {
  return request({
    url: '/helpforum/unlike/question',
    method: 'post',
    data
  })
}

// 取消回复点赞
export function unlikeReply(data) {
  return request({
    url: '/helpforum/unlike/reply',
    method: 'post',
    data
  })
}
